import React, { createContext, useContext, useMemo, useState } from "react";

export type TodoFilter = "todo" | "completed" | "deleted";

type Ctx = {
  filter: TodoFilter;
  setFilter: (f: TodoFilter) => void;
};

const TodoFilterContext = createContext<Ctx | null>(null);

export function TodoFilterProvider({ children }: { children: React.ReactNode }) {
  const [filter, setFilter] = useState<TodoFilter>("todo");

  const value = useMemo(() => ({ filter, setFilter }), [filter]);
  return <TodoFilterContext.Provider value={value}>{children}</TodoFilterContext.Provider>;
}

export function useTodoFilter() {
  const ctx = useContext(TodoFilterContext);
  if (!ctx) throw new Error("useTodoFilter must be used within TodoFilterProvider");
  return ctx;
}
